import {
	createApp
} from 'vue'
import App from './App.vue'
import router from './router.js'
import appjs from './app.js'
// 1. 引入你需要的组件
import {
	Button,
	List,
	Cell,
	PullRefresh,
	Col,
	Row,
	Divider,
	Card,
	NavBar,
	Field,
	CellGroup,
	Uploader,
	Form,
	Notify,
	Tabbar,
	TabbarItem,
	SwipeCell,
	Grid,
	GridItem,
	Search
} from 'vant';
// 2. 引入组件样式
import 'vant/lib/index.css';
const app = createApp(App);

// 3. 注册你需要的组件
app.use(Button);
app.use(List);
app.use(Cell);
app.use(Col);
app.use(Row);
app.use(Divider);
app.use(Card);
app.use(NavBar);
app.use(PullRefresh);
app.use(router);
app.use(Field);
app.use(CellGroup);
app.use(Uploader);
app.use(Form);
app.use(Notify);
app.use(Tabbar);
app.use(TabbarItem);
app.use(SwipeCell);
app.use(Grid);
app.use(GridItem);
app.use(Search);
app.mount('#app')